import { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Link } from 'react-router-dom';
import { Badge } from 'react-bootstrap';
import DataTable from 'react-data-table-component';

import { editarBreadcrumb } from '../../../actions/breadcrumb';
import { obtenerOrden, limpiarOrden } from '../../../actions/ordenes';

import { formatNumber } from '../../../utils/generalFunctions';

const DetallesOrden = () => {

    let rutasBread = [
        {
            activo: false,
            nombre: 'Ordenes',
            path: '/egresos/ordenes'
        },
        {
            activo: true,
            nombre: 'Detalles de la órden',
            path: '/egresos/ordenes/detalles/'
        }
    ];

    const dispatch = useDispatch();

    const { id } = useParams();

    const { detalles } = useSelector(state => state.ordenes);

    const [ordenData, setOrdenData] = useState({
        id: null,
        proveedor: null,
        metodo: null,
        consecutivo: null,
        numero_documento: null,
        fecha: null,
        status: null,
        monto: 0,
        productos: []
    });

    const [unidadesData, setUnidadesData] = useState([]);

    const columns = [
        {
            name: 'Nombre',
            selector: row => row.nombre,
            grow: 2,
            wrap: true
        },
        {
            name: 'Cantidad',
            cell: (row, index) => formatNumber(row.cantidad_surtir, 2, '', '')
        },
        {
            name: 'Unidad',
            cell: (row, index) => unidadesData[index]?.label || 'Sin definir'
        },
        {
            name: 'Costo unitario',
            cell: (row, index) => formatNumber(row.precio_compra / (unidadesData[index]?.cantidad || 1), 2, '$ ', '')
        },
        {
            name: 'Importe',
            cell: (row, index) => formatNumber(row.cantidad_surtir * (row.precio_compra / (unidadesData[index]?.cantidad || 1)), 2, '$ ', '')
        }
    ];

    /* Status orden */
    const statusOrden = (status) => {
        switch(status){
            case 1:
                return(
                    <h5><Badge pill bg="secondary">Pendiente</Badge></h5>
                )

            case 2:
                return(
                    <h5><Badge pill bg="success">Finalizada</Badge></h5>
                )

            case 3:
                return(
                    <h5><Badge pill bg="danger">Cancelada</Badge></h5>
                )
            default:
                break;
        }
    }

    useEffect(() => {
        dispatch(limpiarOrden());

        return () => {
            dispatch(limpiarOrden());
        }
    }, []);

    useEffect(() => {
        if(id){
            dispatch(obtenerOrden(id));

            rutasBread[1].path = rutasBread[1].path + id;

            dispatch(editarBreadcrumb(rutasBread));
        }
    }, [id]);

    useEffect(() => {
        if(detalles){
            setOrdenData({
                ...ordenData,
                id: detalles?.id,
                proveedor: detalles?.proveedor,
                metodo: detalles?.metodo,
                consecutivo: detalles?.consecutivo,
                numero_documento: detalles?.numero_documento,
                fecha: detalles?.fecha,
                status: detalles?.status,
                monto: detalles?.monto,
                productos: detalles?.productos
            });

            setUnidadesData(detalles?.unidades || []);
        }
    }, [detalles]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>

            <div className="row">
                <div className="col-md-12 px-4 pb-4">
                    <h3 className="mb-5 mt-5">Detalles de la órden</h3>

                    <div className="row mt-5 px-3">
                        <div className="col-md-2">
                            <label className="fw-bold">Consecutivo</label>
                            <p>{ordenData?.consecutivo ? ordenData?.consecutivo : 'Sin definir'}</p>
                        </div>

                        <div className="col-md-3">
                            <label className="fw-bold">Número de documento</label>
                            <p>{ordenData?.numero_documento || 'Sin definir'}</p>
                        </div>

                        <div className="col-md-4">
                            <label className="fw-bold">Proveedor</label>
                            <p>{ordenData?.proveedor?.alias || 'Sin definir'}</p>
                        </div>

                        <div className="col-md-3">
                            <label className="fw-bold">Método de pago</label>
                            <p>{ordenData?.metodo?.nombre || 'Sin definir'}</p>
                        </div>

                        <div className="col-md-4">
                            <label className="fw-bold">Fecha</label>
                            <p>{ordenData?.fecha && ordenData?.fecha != '0000-00-00' ? new Date(ordenData?.fecha).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) + ' ' + new Date(ordenData?.fecha).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) : 'Sin definir'}</p>
                        </div>

                        <div className="col-md-2">
                            <label className="fw-bold">Status</label>
                            <p>{statusOrden(ordenData?.status)}</p>
                        </div>

                        <div className="col-md-2">
                            <label className="fw-bold">Total a pagar</label>
                            <p>{formatNumber(ordenData?.monto, 2, '$ ', '')}</p>
                        </div>
                    </div>

                    <hr className="mt-3" />

                    <div className="row mb-3">
                        <h5>Productos</h5>

                        <DataTable
                            columns={columns}
                            data={ordenData.productos}
                            highlightOnHover={true}
                        />

                        <div className="col-md-12 mt-4">
                            <Link to='/egresos/ordenes'><button className="btn btn-secondary float-end">Regresar</button></Link>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default DetallesOrden;
